import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { isUnauthorized, sessionMemory, sessionQuery } from '@/features/auth/session';
import { AppShell } from '@/layouts/AppShell';

/**
 * Everything under here needs a session. The check runs before any child loads, so a child
 * never renders for a signed-out person, and the login screen learns where to send them
 * back to. A 401 after this tab had a session is the "session expired" state; a 401 on a
 * cold visit is just a login.
 */
export const Route = createFileRoute('/_app')({
    beforeLoad: async ({ context, location }) => {
        try {
            const user = await context.queryClient.ensureQueryData(sessionQuery);
            return { user };
        } catch (error) {
            if (isUnauthorized(error)) {
                throw redirect({
                    to: '/login',
                    search: {
                        redirect: location.href,
                        reason: sessionMemory.hadSession() ? 'expired' : undefined,
                    },
                });
            }
            throw error;
        }
    },
    component: () => (
        <AppShell>
            <Outlet />
        </AppShell>
    ),
});
